module.exports = __webpack_public_path__ + "static/top.83bd1f94.png";